// extracted by css-extract-rspack-plugin
export default {"cls1":"MinimalStickyFooter-cls1_2wJ","cls2":"MinimalStickyFooter-cls2_pDx MinimalStickyFooter-cls1_2wJ"};